import Model  from '@/util/models';

export default class Route extends Model { 
    backend = '/rbac/route/'; 
   
    assign(routes){                        
        return this.api.post(this.backend + 'assign', routes); 
    }    
    
    remove(routes){                        
        return this.api.post(this.backend + 'remove', routes); 
    }    
}

